/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_BEVERAGES } from '../../actions.type'
import {
  CREATE_BEVERAGE,
  REMOVE_BEVERAGE,
  SET_BEVERAGE_ALL_REQUEST,
  SET_BEVERAGE_ALL_VALUE,
  UPDATE_BEVERAGE
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  beverageAllValue: (state) => state.all.value,
  beverageAllRequest: (state) => state.all.request,
  beverageAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_BEVERAGES]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('beverage', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_BEVERAGE_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_BEVERAGE_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_BEVERAGE_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_BEVERAGE_ALL_VALUE, data)
    } catch (e) {
      commit(SET_BEVERAGE_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_BEVERAGE({ commit }, value) {
    commit(CREATE_BEVERAGE, value)
  },

  async SOCKET_UPDATE_BEVERAGE({ commit }, value) {
    commit(UPDATE_BEVERAGE, value)
  },

  async SOCKET_REMOVE_BEVERAGE({ commit }, id) {
    commit(REMOVE_BEVERAGE, id)
  }
}

const mutations = {
  [SET_BEVERAGE_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_BEVERAGE_ALL_VALUE](state, beverages) {
    state.all.value = beverages
  },
  [UPDATE_BEVERAGE](state, updatedBeverage) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedBeverage.id }),
      1,
      updatedBeverage
    )
  },
  [CREATE_BEVERAGE](state, createdBeverage) {
    state.all.value.push(createdBeverage)
  },
  [REMOVE_BEVERAGE](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
